import React, { useRef, useState } from "react";
import styles from "./CartBundleOrders.module.scss";
import { Outlet } from "react-router-dom";
import NavTabs from "../../components/mui/tabs/NavTab";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
const tabs = [
  {
    id: "1",
    title: "Pending",
    link: "/cartBundleOrders",
  },
  {
    id: "2",
    title: "completed",
    link: "/cartBundleOrders/completed",
  },
];

const CartBundleOrders = () => {
  return (
    <div className={styles.container}>
    <StatusCard
        leftContent="ORDERS" // or any icon/component
      />
      <div className={styles.top}>
        <NavTabs data={tabs} variant={"fullWidth"} />
      </div>

      <div className={styles.bottom}>
        <Outlet />
      </div>
    </div>
  );
};

export default CartBundleOrders;
